module.exports = __webpack_public_path__ + "img/16_RS-junction.b8faca3a.png";